import React, { lazy } from 'react';
import { Route } from 'react-router-dom';
import landingPagesMeta from '../config/landing-pages-meta.json';

const SeoLandingPage = lazy(() => import('../components/seo/SeoLandingPage'));

/** Routes SEO landing (solutions, comparatifs, verticales). */
export const landingPageRouteElements = landingPagesMeta.pages.map((entry) => {
  const slug = entry.path.replace(/^\//, '');
  return (
    <Route
      key={entry.key}
      path={slug}
      element={<SeoLandingPage pageKey={entry.key} />}
    />
  );
});
